{
    "Timezone_Title_Change": "Benutzerzeitzone ändern",
    "Timezone_Title_Update": "Benutzerzeitzone aktualisieren",
    "Timezone_Dropdown_Title": "Zeitzone",
    "Timezone_Tab_General": "Allgemein",
    "Timeline_Prompt_Change": "Ändern",
    "Timeline_Prompt_Cancel": "Stornieren",
    "Timeline_Prompt_Change_Message": "Wir haben eine Änderung Ihrer Benutzerzeitzone festgestellt \n \n Sie war ursprünglich **{}** \n \n Möchten Sie Ihre lokale Zeitzone auf **{}** ändern?",
    "Timeline_Prompt_First_Time_Message": "Ihre aktuelle Berichtszeitzone ist auf **{}** eingestellt. \n \n Möchten Sie Ihre Berichte auf Ihre lokale Zeitzone aktualisieren? **{}**",
    "NAME": "TimezoneModal"
}